import {
  USER_STATS_TAB,
  isUserStatsTab,
  type UserStatsTab,
} from '../constants/user-stats-tab';

const TAB_PARAM = 'tab';

export function getUserStatsTabFromUrl(
  searchParams: URLSearchParams,
): UserStatsTab {
  const tab = searchParams.get(TAB_PARAM) ?? '';
  if (isUserStatsTab(tab)) return tab;
  return USER_STATS_TAB.OVERVIEW;
}
